import React from 'react';
import { ZapIcon, TrendingUpIcon, ShieldCheckIcon, SearchIcon, CheckCircleIcon, ArrowRightIcon, CheckIcon, SparklesIcon, ClockIcon } from 'lucide-react';
export function HeroSection() {
  return <>
      <section id="home" className="relative min-h-screen pt-24 lg:pt-28 pb-16 lg:pb-24 overflow-hidden" style={{
      background: 'linear-gradient(145deg, #1E3A8A 0%, #1E40AF 40%, #2563EB 100%)'
    }} data-id="element-550" data-mp="23wcy60uu86kx">
        {/* Background decorative elements */}
        <div className="absolute inset-0 pointer-events-none overflow-hidden" data-id="element-551" data-mp="30ksq23lf6s17">
          {/* Large gradient orb */}
          <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full opacity-20 blur-3xl" style={{
          background: 'radial-gradient(circle, #60A5FA 0%, transparent 70%)'
        }} data-id="element-552" data-mp="2mtnoux2elror" />
          <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full opacity-10 blur-3xl" style={{
          background: 'radial-gradient(circle, #3B82F6 0%, transparent 70%)'
        }} data-id="element-553" data-mp="3kacvd42ati4h" />
          {/* Dot pattern */}
          <div className="absolute inset-0 opacity-[0.04]" style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
          backgroundSize: '32px 32px'
        }} data-id="element-554" data-mp="2p5lh0s61oc4q" />
          {/* Norden rocket — subtle background */}
          <div className="absolute bottom-0 right-0 opacity-[0.08]" data-id="element-555" data-mp="2u3wm6ple9ygm">
            <img src="https://cdn.magicpatterns.com/uploads/u5Q7Jx9cFVaD48nmqCDvz9/Norden_met_raket.png" alt="" className="w-64 lg:w-[360px] h-auto translate-x-8 translate-y-4" data-id="element-556" data-mp="384fve01ljakd" />
          </div>
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-557" data-mp="1drznkut5jode">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center min-h-[70vh]" data-id="element-558" data-mp="18swijad69i5f">
            {/* Left column — Emotional copy */}
            <div className="space-y-8" data-id="element-559" data-mp="3ds5yza0vcpg0">
              {/* Floating USP badges */}
              <div className="flex flex-wrap gap-3 animate-fade-in-up" data-id="element-560" data-mp="3irimzy3h82k6">
                <span className="inline-flex items-center gap-1.5 bg-white/10 backdrop-blur-sm border border-white/20 text-white text-xs font-semibold px-3 py-1.5 rounded-full animate-float" data-id="element-561" data-mp="3iq7l63tld4vp">
                  <ZapIcon className="w-3.5 h-3.5 text-yellow-400" data-id="element-562" data-mp="3rrns21l76ov6" />
                  Binnen 2 weken live
                </span>
                <span className="inline-flex items-center gap-1.5 bg-white/10 backdrop-blur-sm border border-white/20 text-white text-xs font-semibold px-3 py-1.5 rounded-full animate-float-delay-1" data-id="element-563" data-mp="jjislpxevtq">
                  <TrendingUpIcon className="w-3.5 h-3.5 text-green-400" data-id="element-564" data-mp="edaqrpo0e7nc" />
                  Meer conversie
                </span>
                <span className="inline-flex items-center gap-1.5 bg-white/10 backdrop-blur-sm border border-white/20 text-white text-xs font-semibold px-3 py-1.5 rounded-full animate-float-delay-2" data-id="element-565" data-mp="jbm101i7uk63">
                  <ShieldCheckIcon className="w-3.5 h-3.5 text-blue-300" data-id="element-566" data-mp="1yv21cs5qulno" />
                  Volledig ontzorgd
                </span>
                <span className="inline-flex items-center gap-1.5 bg-white/10 backdrop-blur-sm border border-white/20 text-white text-xs font-semibold px-3 py-1.5 rounded-full animate-float-slow" data-id="element-567" data-mp="1uu9prs9eg4o8">
                  <SearchIcon className="w-3.5 h-3.5 text-purple-300" data-id="element-568" data-mp="2mkebbu8waxr1" />
                  SEO-proof
                </span>
              </div>

              {/* H1 */}
              <h1 className="text-4xl sm:text-5xl lg:text-[3.5rem] xl:text-6xl font-extrabold text-white leading-[1.1] animate-fade-in-up-delay-1" data-id="element-569" data-mp="2drsqm8lpegzk">
                Websites voor financiële dienstverleners in Alkmaar & Amsterdam
              </h1>

              {/* Subtitle */}
              <p className="hidden lg:block text-lg lg:text-xl text-white/85 max-w-lg leading-relaxed animate-fade-in-up-delay-2" data-id="element-570" data-mp="31igcxywd995n">
                Stop met dure Google Ads en marketingbureaus die alleen
                rapporten sturen. Wij bouwen websites voor accountants en
                adviseurs (1-5 medewerkers) die zorgen voor een structurele
                stroom aan nieuwe klanten.
              </p>

              {/* Trust points */}
              <div className="space-y-3 animate-fade-in-up-delay-3" data-id="element-571" data-mp="2h1lxt1wwmwlq">
                <div className="flex items-center gap-3" data-id="element-572" data-mp="34qenwhquia8f">
                  <CheckCircleIcon className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-573" data-mp="34t0w8jlk8trp" />
                  <span className="text-white font-medium" data-id="element-574" data-mp="38uclup4fpezw">
                    Vaste prijs vooraf, geen verrassingen
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-575" data-mp="2zywovz8dujq3">
                  <CheckCircleIcon className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-576" data-mp="3npir39vph9s6" />
                  <span className="text-white font-medium" data-id="element-577" data-mp="3nno5rugivfnk">
                    Lokaal aanspreekpunt in begrijpelijke taal
                  </span>
                </div>
                <div className="flex items-center gap-3" data-id="element-578" data-mp="5o3tk4m9cza2">
                  <CheckCircleIcon className="w-5 h-5 text-green-400 flex-shrink-0" data-id="element-579" data-mp="1ol9tc66au8t" />
                  <span className="text-white font-medium" data-id="element-580" data-mp="ff6tv47d5a8a">
                    Geen lock-in, jij bent 100% eigenaar
                  </span>
                </div>
              </div>

              {/* Social proof line */}
              <p className="text-white/50 text-sm animate-fade-in-up-delay-4" data-id="element-581" data-mp="3ivf0idkzksxu">
                Gespecialiseerd in accountancy & financieel advies • SEO
                inbegrepen
              </p>
            </div>

            {/* Right column — Prijsscan CTA */}
            <div className="animate-fade-in-up-delay-3" data-id="element-582" data-mp="3nv9pgbl7b8g9">
              <div className="bg-white rounded-2xl shadow-2xl p-7 lg:p-9 relative overflow-hidden" data-id="element-583" data-mp="3ntou4jr2blhc">
                {/* Decorative gradient blob */}
                <div className="absolute -top-20 -right-20 w-64 h-64 rounded-full opacity-30 blur-3xl pointer-events-none" style={{
                background: 'radial-gradient(circle, #DBEAFE 0%, transparent 70%)'
              }} data-id="element-584" data-mp="135avx74wl1x6" />

                <div className="relative" data-id="element-585" data-mp="1k65amq9bgxpt">
                  {/* Icon */}
                  <div className="w-14 h-14 rounded-2xl bg-accent-light flex items-center justify-center mb-5 mt-2" data-id="element-586" data-mp="1p5htz10zbmnn">
                    <SparklesIcon className="w-7 h-7 text-accent" data-id="element-587" data-mp="ri9fhpzebdv5" />
                  </div>

                  {/* Heading */}
                  <h2 className="text-2xl lg:text-3xl font-extrabold text-navy-900 mb-2 leading-tight" data-id="element-588" data-mp="whm1k8ig0gwo">
                    Wat kost jouw nieuwe website?
                  </h2>
                  <p className="text-sm lg:text-base text-slate-600 mb-6 leading-relaxed" data-id="element-589" data-mp="166x8bohux9he">
                    Doe de gratis prijsscan en ontvang binnen 2 minuten een
                    persoonlijke prijsindicatie op maat van jouw bedrijf.
                  </p>

                  {/* Benefits */}
                  <ul className="space-y-3 mb-7" data-id="element-590" data-mp="673ia4w97rfi">
                    <li className="flex items-start gap-3" data-id="element-591" data-mp="64r29xa23r53">
                      <span className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-592" data-mp="18s9zyllxoze">
                        <CheckIcon className="w-3 h-3 text-green-600" strokeWidth={3} data-id="element-593" data-mp="3sc76hnk9l2tb" />
                      </span>
                      <span className="text-sm text-navy-800 font-medium" data-id="element-594" data-mp="3jewwe5j6njpz">
                        Direct inzicht in de kosten
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-595" data-mp="39ollu04zuca4">
                      <span className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-596" data-mp="34opk67jrqwxq">
                        <CheckIcon className="w-3 h-3 text-green-600" strokeWidth={3} data-id="element-597" data-mp="2zob9siup3awj" />
                      </span>
                      <span className="text-sm text-navy-800 font-medium" data-id="element-598" data-mp="netdh67uf54q">
                        Volledig op maat voor jouw bedrijf
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-599" data-mp="dhevh269u8ab">
                      <span className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-600" data-mp="dizpmqoobp7n">
                        <CheckIcon className="w-3 h-3 text-green-600" strokeWidth={3} data-id="element-601" data-mp="4ov4mnw81801" />
                      </span>
                      <span className="text-sm text-navy-800 font-medium" data-id="element-602" data-mp="3qvtbfe815zer">
                        Klaar in minder dan 2 minuten
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-603" data-mp="3vsjsa3rnsz18">
                      <span className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-604" data-mp="3hwenalfc60xf">
                        <CheckIcon className="w-3 h-3 text-green-600" strokeWidth={3} data-id="element-605" data-mp="3lyt5r4f3eyo6" />
                      </span>
                      <span className="text-sm text-navy-800 font-medium" data-id="element-606" data-mp="2yb66wxlcl25j">
                        Geen verplichtingen achteraf
                      </span>
                    </li>
                  </ul>

                  {/* Primary CTA */}
                  <a href="https://scan.noorddigital.nl/prijsscan" target="_blank" rel="noopener noreferrer" className="w-full bg-accent hover:bg-accent-hover text-white font-bold py-4 rounded-button shadow-medium hover:shadow-card transition-all duration-200 text-base flex items-center justify-center gap-2 animate-pulse-glow group" data-id="element-607" data-mp="3m6qxuithwe1u">
                    Start gratis prijsscan
                    <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-608" data-mp="3tb03aue6yxn" />
                  </a>

                  {/* Trust signals */}
                  <div className="flex items-center justify-center gap-4 mt-5 text-xs text-slate-400" data-id="element-609" data-mp="2qu6bnt9ry7tg">
                    <span className="flex items-center gap-1" data-id="element-610" data-mp="2m0llgnefai4t">
                      <ClockIcon className="w-3.5 h-3.5 text-accent" data-id="element-611" data-mp="2hzi1ppt981yb" />
                      &lt; 2 min
                    </span>
                    <span className="flex items-center gap-1" data-id="element-612" data-mp="2d31h35l9k5pz">
                      <CheckCircleIcon className="w-3.5 h-3.5 text-green-500" data-id="element-613" data-mp="39rr0x1ggb8el" />
                      100% gratis
                    </span>
                    <span className="flex items-center gap-1" data-id="element-614" data-mp="35qnh63va8s83">
                      <ShieldCheckIcon className="w-3.5 h-3.5 text-green-500" data-id="element-615" data-mp="30pq2i19hegbc" />
                      Geen spam
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trust badges strip below hero */}
      <div className="relative bg-white border-b border-navy-100" data-id="element-616" data-mp="1kbhv5dxa8dka">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5" data-id="element-617" data-mp="1a8umc0ybvip0">
          <div className="flex flex-wrap items-center justify-center gap-6 lg:gap-12" data-id="element-618" data-mp="1a6hxr4y2ea2z">
            <span className="flex items-center gap-2 text-sm font-medium text-navy-700" data-id="element-619" data-mp="1f7yx2w0whohg">
              <CheckIcon className="w-5 h-5 text-accent flex-shrink-0" data-id="element-620" data-mp="1k57bclixh8df" />
              WordPress specialist
            </span>
            <span className="flex items-center gap-2 text-sm font-medium text-navy-700" data-id="element-621" data-mp="1ozbojmisecmy">
              <CheckIcon className="w-5 h-5 text-accent flex-shrink-0" data-id="element-622" data-mp="1t16lketoq3ux" />
              SEO geoptimaliseerd
            </span>
            <span className="flex items-center gap-2 text-sm font-medium text-navy-700" data-id="element-623" data-mp="22xjehaheodom">
              <CheckIcon className="w-5 h-5 text-accent flex-shrink-0" data-id="element-624" data-mp="27wcrl1ss62o9" />
              Snelle oplevering
            </span>
          </div>
        </div>
      </div>
    </>;
}